import { useContext, useState } from "react";
import style from "./Login.module.css";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { lapContext } from "../../context/OverLapContext";

function Login() {
  const [seePassword, setSeePassword] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [inputStatus, setInputStatus] = useState(false);
  const [btnStatus, setBtnStatus] = useState(false);
  const navigate = useNavigate();
  const { setStatus } = useContext(lapContext);
  function ClickHandler() {
    setSeePassword((val) => {
      return !val;
    });
  }

  function userNameHandler(e) {
    e.preventDefault();
    setUserName(e.target.value);
  }

  function passwordHandler(e) {
    e.preventDefault();
    setPassword(e.target.value);
  }

  async function formSubmitHandler(e) {
    e.preventDefault();
    setInputStatus(true);
    setBtnStatus(true);
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/userlogin`,
        // `http://localhost:5000/api/v1/user/userlogin`,
        {
          method: "POST",
          body: JSON.stringify({ userName, password }),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (result.status >= 400) {
        setBtnStatus(false);
        setInputStatus(false);
        throw new Error("Bad Credential");
      }
      setStatus(result.ok);
      const userDetails = await result.json();
      if (result.ok) {
        sessionStorage.setItem("user", userDetails?.data?.user?.userType || "No User");
        setInputStatus(false);
        setBtnStatus(false);
        return navigate("/");
      }
    } catch (err) {
      setLoginErrorMsg(err);
    }
  }

  return (
    <>
      <div className={style.container}>
        <div className={style.box}>
          <form onSubmit={formSubmitHandler}>
            <input
              className={style.input}
              style={{ borderBottom: "1px solid rgb(128, 128, 128)" }}
              type="text"
              placeholder="User Name or Email"
              onChange={userNameHandler}
              value={userName}
              disabled={inputStatus}
            ></input>
            <div className={style.passwordBox}>
              <input
                className={style.input}
                type={`${seePassword ? "text" : "password"}`}
                placeholder="Password"
                onChange={passwordHandler}
                value={password}
                disabled={inputStatus}
              ></input>
              <div onClick={ClickHandler}>
                {seePassword ? <FaEye></FaEye> : <FaEyeSlash></FaEyeSlash>}
              </div>
            </div>
            <p className={style.errorMsg}>{loginErrorMsg}</p>
            <div>
              <div className={style.btnBox}>
                <button disabled={btnStatus} className={style.btn}>
                  {btnStatus ? "Wait..." : "Login"}
                </button>
                <a href="/forgetpage">Forget Password</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
